import React from 'react';
import { Button, Modal, Stack, Image } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { useNavigate } from 'react-router-dom';
import useTranslate from 'hooks/useTranslate';

const AssessementSuccess: React.FC<any> = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();

	return (
		<Modal.Body>
			<Stack className="success-modal-content text-center mx-auto gap-4">
				<Image src={IMAGE_PATHS.SuccessGif} alt="success" loading="lazy" />
				<h2 className="fw-bold mb-0">{translate('Modal.appliedSuccessfully')}</h2>
				<Button
					className="transparent-btn rounded-pill mx-auto"
					onClick={() => {
						navigate('/job-search?keyword=&cityId=&stateId=&countryId=&location=&industryId=');
					}}
				>
					{translate('Modal.searchMoreJobs')}
				</Button>
			</Stack>
		</Modal.Body>
	);
};

export default AssessementSuccess;
